import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let swipers = document.querySelectorAll('noss-projects[paws-template="slider"] .swiper');

    for (let i = 0; i < swipers.length; ++i) {
        let mySwiper = new Swiper(swipers[i], {
            slidesPerView: 1.4,
            spaceBetween: 25,
            slideToClickedSlide: true,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            breakpoints: {
                992: {
                    slidesPerView: 3.5,
                    spaceBetween: 50,
                    centeredSlides: true,
                },
            },
            on: {
                init: function () {
                    if (window.lazyLoadInstance) {
                        window.lazyLoadInstance.update();
                    }
                },
            },
        });

    }
}